module.exports = __webpack_public_path__ + "img/logo-a4.62946183.png";